import React from 'react';
import { graphql } from 'gatsby';
import SiteHeader from '../components/SiteHeader/SiteHeader';
import Container from '../components/Container/Container';
import ParagraphHeader from '../components/Paragraph/ParagraphHeader';
import ParagraphMiniHeader from '../components/Paragraph/ParagraphMiniHeader';
import Paragraph from '../components/Paragraph/Paragraph';
import ParagraphList from '../components/Paragraph/ParagraphList';
import UserImage from '../components/UserImage/UserImage';

const Montaz = ({ data }) => {
  return (
    <>
      <SiteHeader
        image={data.file.childImageSharp.gatsbyImageData}
        text='Montaż'
      />
      <Container padding='32px 16px' width='740px'>
        <UserImage />
        <ParagraphHeader>Usługa montażu</ParagraphHeader>
        <Paragraph>
          Zapewniamy profesjonalny pomiar i montaż oferowanych materiałów przez
          autoryzowanego wykonawcę.
          <br /> W celu ustalenia terminu, oraz kosztorysu usługi, prosimy o
          kontaktowanie się z Jackiem Lewandowskim pod numerem telefonu 608 829
          646.
        </Paragraph>
        <ParagraphHeader>Wskazówki dla wykonawców</ParagraphHeader>
        <ParagraphHeader danger>
          Tapeta nie może mieć kontaktu ze źródłem elektryczności. Przy
          układaniu tapet w pobliżu gniazdek, przełączników elektrycznych należy
          zachować szczególną ostrożność.
        </ParagraphHeader>
        <ParagraphMiniHeader>Informacje ogólne</ParagraphMiniHeader>
        <ParagraphList>
          <li>
            Przed przycięciem tapety należy sprawdzić, czy nie jest ona
            uszkodzona i nie ma innych wad widocznych. W ramach reklamacji nie
            będą rozpatrywane roszczenia dotyczące kosztów innych niż
            reklamowana tapeta.
          </li>
          <li>
            W przypadku ciemnych tapet rekomenduje się pokolorowanie brzegu
            tapety markerem w odpowiednim kolorze by ukryć jasne brzegi w
            przypadku popełnienia błędów w kładzeniu. Innym sposobem
            zabezpieczenia się przed drobnymi niedokładnościami w kładzeniu
            tapety może być wcześniejsze pomalowanie fragmentów ściany w
            przewidywanych miejscach styku brytów.
          </li>
          <li>
            Na wszelki wypadek należy zachować rezerwy tapety (z reguły
            zakupiona ilość tapety powinna być większa od powierzchni do
            pokrycia o 10%).
          </li>
          <li>
            Należy zachować informacje dotyczącą numeru partii produkcyjnej (z
            ang. – batch number, lot number). Numer ten będzie niezbędny przy
            ewentualnym domawianiu tej samej tapety, aby nowe rolki pochodziły z
            tej samej partii i nie różniły się odcieniem.
          </li>
        </ParagraphList>
        <ParagraphMiniHeader>Przed rozpoczęciem klejenia</ParagraphMiniHeader>
        <ParagraphList>
          <li>
            Prosimy o sprawdzenie, czy dostarczona tapeta zgadza się z
            zamówieniem. Przed pocięciem i położeniem tapety należy sprawdzić
            każdą rolkę, czy nie ma widocznych uszkodzeń, wzory i kolory do
            siebie pasują (czy rolki pochodzą z tej samej partii produkcyjnej –
            batch number widoczny na etykiecie rolki). Za sprawdzenie produktu
            odpowiada kupujący.
          </li>
          <li>
            Po położeniu 2/3 wysokości (bryt) należy powtórnie upewnić się, czy
            na tapetach nie występują różnice kolorystyczne lub uszkodzenia.
            Jeżeli zauważone zostaną wady jakościowe należy przerwać kładzenie
            tapet i skontaktować się ze sprzedawcą.
          </li>
          <li>
            Reklamacje przekraczające 2/3 wysokości a dotyczące wad widocznych
            nie będą akceptowane. Każde zgłoszenie reklamacji musi być wsparte
            próbką tapety, numerem referencyjnym produktu oraz numerem partii
            produkcyjnej/kąpieli.
          </li>
        </ParagraphList>
        <ParagraphMiniHeader>Przygotowanie podłoża</ParagraphMiniHeader>
        <ParagraphList>
          <li>
            Prawidłowe przygotowanie podłoża przed instalacją tapet jest
            najważniejszą czynnością oraz warunkiem koniecznym dla uzyskania
            dobrego efektu końcowego. Czynność tą należy wykonać niezwykle
            starannie.
          </li>
          <li>
            Podłoże musi być czyste, suche, o niskiej chłonności (w razie
            potrzeby zagruntowane), gładkie oraz wolne od kurzu i pozostałości
            po pigmentach (jednolita neutralna barwa podłoża), które mogłyby
            wsiąkać w tapetę.
          </li>
          <li>
            Starą tapetę należy usunąć. Warstwy starej farby (szczególnie
            olejnej), które częściowo lub całkowicie pokrywają ścianę mogą
            utrudnić wnikanie kleju w podłoże. Najlepiej je zeskrobać a w
            ostateczności dokładnie przetrzeć papierem ściernym i odtłuścić.
            Wszelkie ubytki, rysy i nierówności należy uzupełnić, a następnie
            przetrzeć papierem ściernym, po czym umyć wodą z preparatem
            odtłuszczającym i zagruntować.
          </li>
          <li>
            Przy powierzchniach mocno wchłaniających lub porowatych ścianach
            (suche sztukaterie, panele gipsowe itp.), konieczne jest
            zastosowanie środka gruntującego (na co najmniej 24 godziny przed
            rozpoczęciem tapetowania). Jeżeli nie wiadomo, czy ściana wymaga
            gruntowania, można ją zagruntować profilaktycznie. Przed
            naniesieniem gruntu należy dokonać próby, czy środek wnika w głąb.
            Jeżeli pozostaje na powierzchni ściany należy przerwać gruntowanie.
            Zbyt duża ilość nałożonego gruntu może spowodować obniżoną
            przyczepność kleju a tym samym i tapety.
          </li>
          <li>
            Ściany świeżo tynkowe – przed klejeniem tapety należy sprawdzić, czy
            powierzchnia wyschła. Ewentualnie w przypadku ściany niedawno
            tynkowanej powinno się poprzez gruntowanie zneutralizować zasady,
            które mogą być w nich obecne.
          </li>
          <li>
            Nie wolno kleić tapet na wilgotnych powierzchniach. Należy poczekać,
            aż ściany będą całkowicie suche. Niezastosowanie się do tych zaleceń
            powoduje ryzyko zmniejszenia przyczepności kleju oraz powstania
            pleśni.
          </li>
        </ParagraphList>
        <ParagraphMiniHeader>Klej</ParagraphMiniHeader>
        <Paragraph>
          Wybór klejów na rynku jest szeroki i każdy fachowiec stosuje
          wypróbowane i sprawdzone przez siebie rodzaje klejów. Poza
          specjalistycznymi klejami do nakładania tapet winylowych można
          stosować ogólnodostępny na rynku METHYL SPEZIAL (125g/4,5l wody) z
          dodatkiem 25% kleju PVA (biały klej do tapet).
          <br />
          Proponujemy jednak stosować kleje profesjonalne o wysokiej jakości: –
          do tapet na podłożu papieru stosować klej Quelyd, – do tapet na
          osnowie nietkanej (non-woven) Pufas.
        </Paragraph>
        <ParagraphMiniHeader>Klejenie tapety</ParagraphMiniHeader>
        <Paragraph>
          Przy nakładaniu tapety konieczne jest zastosowanie się do instrukcji
          podanej przez producenta na odwrocie tapety – piktogramy (druga
          strona). Określają one metodę nakładania tapet oraz, czy metoda wymaga
          jakiś modyfikacji w stosunku do dwóch podstawowych metod opisanych
          poniżej.
        </Paragraph>
        <Paragraph>
          <strong>Metoda I</strong>
          <br />
          <strong>Klej na tapetę dla tapet o podłożu papierowym</strong>
        </Paragraph>
        <ParagraphList>
          <li>
            Przyciąć tapetę na długość pamiętając o odpowiednim dopasowaniu
            wzoru. Należy zostawić niewielki zapas na długości tapety ok. 5cm.
          </li>
          <li>
            Nałożyć klej na tapetę. Przy nakładaniu kleju należy zwrócić
            szczególną uwagę na dokładne pokrycie brzegów tapet. Nie należy
            nakładać zbyt dużej ilości kleju oraz nie należy pokrywać klejem
            więcej nić jednej kawałka/brytu wysokości w danym momencie.
          </li>
          <li>
            Pasek tapety ostrożnie złożyć stronami posmarowanymi klejem do
            środka, tak aby cała posmarowana klejem powierzchnia była
            niewidoczna i nie miała styczności z powietrzem, co zapobiegnie jej
            wysychaniu. Należy uważać, aby nie zrobić zagnieceń na zgięciu
            tapety. Będą one widoczne po ułożeniu tapety.
          </li>
          <li>
            Pozostawić tapetę na 5-10min do nasiąknięcia (w przypadku niektórych
            tapet potrzebny czas może być dłuższy). Tapety winylowe i papierowe
            (typ.1) smaruje się klejem. Ulegają one pęcznieniu co może powodować
            rozszerzenie tapety do ok. 1 cm.
          </li>
          <li>
            Pasy tapety należy kłaść od góry ściany, w ten sposób aby jedna ze
            złożonych jeszcze części swobodnie opadała w dół. Następnie bardzo
            dokładnie dopasować wzór do naklejonego poprzednio brytu tapety.
          </li>
          <li>
            Wszystkie brzegi tapet są firmowo przycięte i powinny być łączone na
            styk za pomocą wałka lub miękkiej szczotki. Szczególnie delikatnie
            należy postępować w przypadku tapet z fakturą.
          </li>
          <li>
            Usunąć pęcherzyki powietrza za pomocą wałka lub miękkiej szczotki.
          </li>
          <li>Przyciąć ostrym nożem górną i dolną krawędź.</li>
          <li>
            Usunąć nadmiar kleju lekko wilgotną i czystą gąbką. Należy to czynić
            po nałożeniu każdego pasma tapety aby klej nie wysechł. W żadnym
            wypadku nie trzeć wielokrotnie w tym samym miejscu lub używać
            chemicznych środków czystości. Wysychający klej może zniszczyć
            powierzchnię tapety.
          </li>
        </ParagraphList>
        <Paragraph>
          <strong>Metoda II</strong>
          <br />
          <strong>
            Klej na ścianę (w przypadku tapet na osnowie nietkanej, które nie
            zmieniają wymiarów pod wpływem kontaktu z klejem).
          </strong>
        </Paragraph>
        <ParagraphList>
          <li>
            Równomiernie nałożyć cienką warstwę kleju na ścianę za pomocą wałka
            lub pędzla. Klej nakładać systematycznie tak, aby nie wysechł przed
            położeniem tapety. Najlepiej na powierzchnię nieco tylko większą niż
            nakładany pasek tapety.
          </li>
          <li>
            Nakładać przycięte suche pasy tapety na pomalowaną klejem ścianę.
          </li>
          <li>Dalej postępować, jak w pierwszej metodzie od punktu nr 5.</li>
        </ParagraphList>
        <Paragraph>
          <strong>Tapety metalizowane, tapety holograficzne</strong>
          <br />
          Szczególnie ważne jest przygotowanie podłoża przed przyklejaniem
          tapet.
        </Paragraph>
        <ParagraphList>
          <li>
            Powierzchnie świeżo otynkowane lub wypełnione powinny być pokryte
            zasadowo odpornym gruntem. Przed podjęciem dalszych czynności grunt
            powinien całkowicie wyschnąć.
          </li>
          <li>
            Wszystkie powierzchnie powinny być pokryte podkładowym papierem o
            dużej grubości, po czym ponownie pozostawione do całkowitego
            wyschnięcia.
          </li>
          <li>
            Po przyklejeniu podkładowego papieru nie powinny być już stosowane
            żadne dodatkowe środki chemiczne czy wypełnienia.
          </li>
          <li>
            Tapety powinny zostać powieszone przy użyciu dobrej jakości kleju w
            formie gotowej mieszanki, nie zawierającego rozpuszczalników.
            Proponujemy użycie kleju Wallfix Contract.
          </li>
        </ParagraphList>
        <Paragraph>
          <strong>Podwójne docinanie</strong>
          <br />
          Podwójne cięcie jest często dobrym sposobem na osiągnięcie doskonale
          niewidocznych łączeń. Jest to szczególnie przydatne podczas montowania
          grubych, tłoczonych tapet, gdzie nałożone na siebie bryty są
          szczególnie widoczne.
        </Paragraph>
        <ParagraphList>
          <li>
            Aby osiągnąć idealne połączenie brytów tapety nałóż je na siebie na
            zakładkę z sąsiadującymi krawędziami. Następnie przyłóż metalową
            linijkę pośrodku łączenia, dociśnij wystarczająco mocno i przetnij
            obie warstwy tapety. Rozpocznij cięcie z góry do dołu.
          </li>
          <li>
            Usuń odciętą tapetę podtrzymując tapetę linijką (w ten sposób tapeta
            nie podrze się)Podnieść lekko krawędź tapety, by zdjąć drugi odcięty
            pasek, a następnie wygładź brzegi tapety. Zetrzyj nadmiar kleju,
            który pojawi się na krawędzi za pomocą czystej wilgotnej gąbki.
          </li>
          <li>
            Na następnej ścianie, odmierz szerokość tapety i poprowadź pion (nić
            z ciężarkiem).
          </li>
          <li>
            Za pomocą pionu, przyklej kolejny bryt zaczynając od rogu ściany tak
            aby krawędź następnego brytu nachodziła na już przyklejony.
          </li>
          <li>
            Klejenie na tak zwana zakładkę w narożnikach ścian jest bardzo ważne
            przy kładzeniu tapet winylowych.
          </li>
          <li>
            Przy grubych tapetach może być konieczne zastosowanie zakładki i
            podwójnego cięcia.
          </li>
          <li>
            Na rogach zewnętrznych, w szczególności jeśli tapeta jest mocno
            tłoczona może również być wymagane podwójne docinanie.
          </li>
        </ParagraphList>
      </Container>
    </>
  );
};

export const query = graphql`
  {
    file(name: { eq: "assembly-background_wm_enlarge_karabane-75162858b" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
  }
`;

export default Montaz;
